import React from 'react'
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { StoreProvider, useStore } from './context/StoreContext'
import Login from './components/Login'
import Dashboard from './components/Dashboard'
import Sales from './components/Sales'
import Analytics from './components/Analytics'
import Inventory from './components/Inventory'
import Facility from './components/Facility'
import Order from './components/Order'
import Settings from './components/Settings'
import MobileStoreSettings from './components/MobileStoreSettings'
import Vendors from './components/Vendors'
import AccessLogs from './components/AccessLogs'
import ScrollToTop from './components/ScrollToTop'
import { AlertProvider, useAlert } from './context/AlertContext'
import CustomAlert from './components/CustomAlert'
import AutoLogout from './components/AutoLogout'
import LandingPage from './components/LandingPage'

// 로그인 여부를 확인하여 보호된 라우트를 처리하는 컴포넌트
const ProtectedRoute = ({ children }) => {
  const { user, isLoading, logout } = useStore();
  const { showAlert } = useAlert();

  if (isLoading) {
    return null; // 또는 로딩 스피너
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // admin1, admin2, admin3 계정은 PC(768px 초과)에서 접근 시 강제 로그아웃 처리
  const restrictedAdmins = ['admin1', 'admin2', 'admin3'];
  const isManager = user.role === 'manager';

  if ((restrictedAdmins.includes(user.id) || isManager) && window.innerWidth > 768) {
    const roleName = isManager ? '매니저' : `관리자${user.id.slice(-1)}`;
    showAlert(`${roleName} 계정은 모바일 기기에서만 접근 가능합니다.`);
    logout(); 
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  React.useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <StoreProvider>
      <AlertProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
            <CustomAlert />
            <AutoLogout />
            <Routes>
            <Route path="/login" element={<Login />} />
            
            <Route path="/landing" element={
              <ProtectedRoute>
                <LandingPage />
              </ProtectedRoute>
            } />

            {/* Protected Routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/analytics" element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            } />
            <Route path="/vendors" element={
              <ProtectedRoute>
                <Vendors />
              </ProtectedRoute>
            } />
            <Route path="/access-logs" element={
              <ProtectedRoute>
                <AccessLogs />
              </ProtectedRoute>
            } />

            {/* Store Specific Protected Routes */}
            <Route path="/store/:id/sales" element={
              <ProtectedRoute>
                <Sales />
              </ProtectedRoute>
            } />
            <Route path="/store/:id/inventory" element={
              <ProtectedRoute>
                <Inventory />
              </ProtectedRoute>
            } />
            <Route path="/store/:id/facility" element={
              <ProtectedRoute>
                <Facility />
              </ProtectedRoute>
            } />
            <Route path="/store/:id/order" element={
              <ProtectedRoute>
                <Order />
              </ProtectedRoute>
            } />
            <Route path="/store/:id/settings" element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            } />
            <Route path="/store/:id/mobile-settings" element={
              <ProtectedRoute>
                <MobileStoreSettings />
              </ProtectedRoute>
            } />

            {/* Default redirection */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/store/:id" element={<Navigate to="sales" replace />} />
          </Routes>
        </div>
        </Router>
      </AlertProvider>
    </StoreProvider>
  )
}

export default App

